import React, { Fragment, useState } from "react";
import {
  EuiInMemoryTable,
  EuiSpacer,
  EuiButtonIcon,
  EuiFlexGroup,
  LEFT_ALIGNMENT,
} from "@elastic/eui";
import { useEffect } from "react";
import OrganizationService from "../../services/organization-service";
import {
  EuiBadge,
  EuiModal,
  EuiModalHeader,
  EuiModalBody,
  EuiButton,
  EuiModalFooter,
} from "@elastic/eui";
import UserCreate from "./UserCreate";
import UserManageLicenses from "./UserManageLicenses";

const UsersTable = (props) => {
  const [users, setUsers] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalLicenses, setModalLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isClosed, setIsClosed] = useState(true);

  const toggleIsClosed = () => setIsClosed((prevState) => !prevState);

  const showModal = (licenses) => {
    setIsModalVisible(true);
    setModalLicenses(licenses);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const renderModal = () => {
    return (
      <EuiModal onClose={closeModal} style={{ width: "800px" }}>
        <EuiModalHeader>
          <h1>
            <b>Assigned Licenses</b>
          </h1>
        </EuiModalHeader>
        <EuiModalBody>
          {modalLicenses.map((license, index) => (
            <div>
              <EuiBadge color={"#d83b01"} key={index}>
                {license}
              </EuiBadge>
              <EuiSpacer size="xs" />
            </div>
          ))}
        </EuiModalBody>
        <EuiModalFooter>
          <EuiButton onClick={closeModal}>Close</EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  };

  useEffect(() => {
    setUsers([]);
    setLoading(true);

    const organizationId = props.data.company;
    const token = sessionStorage.getItem("krakenT");
    const isDatabaseCompany = props?.data?.permissions === "database";

    const request = isDatabaseCompany
      ? OrganizationService.getTeamsUsersByPowershell({ token, organizationId })
      : OrganizationService.getMsUsersByGraph({ token, organizationId });

    request
      .then(({ data: { data: users } }) => {
        setUsers(Array.isArray(users) ? users : []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setUsers([]);
        setLoading(false);
      });
  }, [props.data.company, props.data.permissions, isClosed]);

  const extensionClicked = (item) => {
    console.log(item);
    props.setEditData(item);
    props.openFlyoutEdit();
  };

  const actions = [
    {
      name: "Edit",
      description: "Click here to edit user",
      align: "left",
      icon: "documentEdit",
      type: "icon",
      render: (item) => {
        return (
          <UserManageLicenses
            props={props}
            closeModalProp={toggleIsClosed}
            item={item}
          />
        );
      },
      onClick: (item) => extensionClicked(item),
    },
  ];

  const columns = [
    {
      name: "",
      width: 30,
      actions,
    },
    {
      field: "name",
      name: "Name",
      sortable: true,
      truncateText: true,
    },
    {
      field: "mail",
      name: "EMAIL",
      sortable: true,
      truncateText: true,
    },
    {
      field: "country",
      name: "Country Code",
      sortable: true,
      truncateText: true,
    },
    {
      field: "assignedLicenses",
      name: "Assigned Licenses",
      render: (licenses = []) => {
        const safeLicenses = Array.isArray(licenses) ? licenses : [];
        const maxVisibleLicenses = 3;
        if (safeLicenses.length <= maxVisibleLicenses) {
          return safeLicenses.map((license, index) => (
            <EuiBadge color={"#d83b01"} key={index}>
              {license}
            </EuiBadge>
          ));
        } else {
          const visibleLicenses = safeLicenses
            .slice(0, maxVisibleLicenses)
            .map((license, index) => (
              <EuiBadge color={"#d83b01"} key={index}>
                {license}
              </EuiBadge>
            ));
          const moreBadge = (
            <EuiBadge
              color="gray"
              onClick={() => showModal(safeLicenses)}
              key="more"
            >
              {`${safeLicenses.length - maxVisibleLicenses} more...`}
            </EuiBadge>
          );
          return [...visibleLicenses, moreBadge];
        }
      },
      sortable: true,
      truncateText: true,
      width: "40%",
    },
  ];

  const search = {
    box: {
      incremental: true,
      schema: true,
    },
  };

  return (
    <Fragment>
      <UserCreate props={props} closeModalProp={toggleIsClosed} />

      <EuiSpacer size="l" />
      <EuiInMemoryTable
        message={loading ? "Loading ..." : "No items found"}
        loading={loading}
        tableCaption="User List"
        items={users}
        columns={columns}
        search={search}
        pagination={true}
        sorting={true}
      />
      {isModalVisible && renderModal()}
    </Fragment>
  );
};

export default UsersTable;
